<template>
    <div class="register-step-3">
        <form action="#"
              @submit.prevent="submitForm"
              class="form"
              ref="form"
        >
            <div class="payout-wrapper" ref="payoutInformation">
                <div class="margin-top-20 margin-bottom-20">
                    <PayoutInformation ref="payoutInformationComponent"
                                       :user-data="userData"
                                       :static-data="staticData"
                                       :userRoles="userRoles"
                                       :edit-mode="true"
                                       :show-non-editable="true"
                                       :show-title="true"
                                       :errors="this.registerStepErrors"
                                       @setPayoutFormState="setPayoutFormState"
                                       @componentLoading="componentLoading"
                    />
                </div>
            </div>

            <div class="row hh-form-btn-wrapper margin-bottom-20 margin-top-20">
                      <div class="form-group col-sm-6">
                        <button type="button"  v-on:click="backAction"
                                class="btn hh-btn back-btn" name="Back">
                          Back
                        </button>
                      </div>
                      <div class="form-group col-sm-6">
                        <button type="submit" :disabled="!isFormReady"
                                class="btn save-btn hh-btn-green" name="Create account">
                         Create Account
                        </button>
                      </div>
            </div>

        </form>
    </div>
</template>

<script>
  import vSelect from 'vue-select'
  import PayoutInformation from '../../../components/form/PayoutInformation'
  import { scrollTo } from '../../../utils/componentHelper'

  export default {
    name: 'Step-4',

    components: {
      vSelect,
      PayoutInformation,
    },

    props: {
      userData: {
        business_type: String,
        business_name: String,
        url: String,
        identification_number: String,
        account_number: String,
        routing_number: String,
      },
      staticData: Object,
      userRoles: Array,
    },

    data: () => {
      return {
        loading: true,
        isPayoutFormReady: true,
        componentsLoadingStatus: {
          PayoutInformation: true,
        },
        formData: {
          opType: 'update',
          step: 4,
        },
      }
    },

    mounted () {
      this.loading = false
    },

    methods: {
      submitForm () {
        this.loading = true

        if (!this.$refs.payoutInformationComponent.canSubmit()) {
          scrollTo(this.$refs['form'])
          this.loading = false
          return false
        }

        this.processFormData()
        this.sendFormData()
      },

      processFormData () {
        this.formData = { ...this.formData, ...this.$refs.payoutInformationComponent.$data.formData }
      },

      sendFormData () {
        this.$store.dispatch('registerStep', this.formData).then(() => {
          if (this.registerStepStatus === 'success') {
            this.$store.commit('setAlert', {
              message: 'Congratulations, you have successfully registered!',
              type: 'bg-success'
            })

           window.fbq('trackCustom', 'Registration', {type: 'organizer'});
           gtag('event', 'create_an_account__organizer_', {'event_category': 'Registration', 'event_label': 'Signup', 'value': 0, 'send_to': ['G-XYNG531DN3', 'G-QMLYKDX5HS']});

            this.$store.dispatch('fetchAuthUser').then(() => {
              this.$store.dispatch('profile/fetchData').then(() => {
                this.loading = false

                let intendedCampaignUrl = localStorage.getItem('intendedCampaignUrl')
                if (!_.isEmpty(intendedCampaignUrl)) {
                  localStorage.removeItem('intendedCampaignUrl')
                  window.location = intendedCampaignUrl
                } else {
                  this.$router.push({ name: 'profile' })
                }
              })
            })
          } else {
            this.loading = false
          }
        })
      },

      backAction () {
        this.$emit('navigateBack')
      },

      componentLoading (componentName, value) {
        this.componentsLoadingStatus[componentName] = value
      },

      setPayoutFormState (value) {
        this.isPayoutFormReady = value
      },
    },

    computed: {
      registerStepStatus: {
        get () {
          return this.$store.getters['registerStepStatus'](this.formData.step)
        },
      },

      registerStepErrors: {
        get () {
          return this.$store.getters['registerStepErrors'](this.formData.step)
        },
      },

      hasErrors () {
        return this.registerStepStatus === 'failed'
      },

      isFormReady () {
        return !this.loading && this.isPayoutFormReady
      },

      isLoading () {
        for (let component in this.componentsLoadingStatus) {
          if (this.componentsLoadingStatus[component]) {
            return true
          }
        }

        return this.loading
      },

      available_business_types () {
        let result = []

        for (const [key, value] of Object.entries(this.staticData.available_business_types)) {
          result.push({ label: value, code: key })
        }

        return result
      },

    },

    watch: {
      isLoading (to, from) {
        this.$emit('componentLoading', 'stepComponent', to)
      }
    },
  }
</script>

<style scoped>

</style>
